import { urlFunction } from "app/main/types";
import { cleanStringForURL } from "app/main/urlFormatter";
import { clientConfig } from "app/config";

export const stockIndexUrlFunction: urlFunction = (isin, title) => {
    const cleanName = cleanStringForURL(title);
    return `${clientConfig.urlPathPrefixStocks}indizes/${cleanName}/${isin.toLowerCase()}`;
};
